import { Component, ChangeDetectionStrategy, Input } from '@angular/core';
import { BaseInputEditor } from './base-editor';
import { CELL_EDITOR_STYLES } from './cell-editor.styles';

@Component({
  selector: 'ct-number-editor',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styles: [CELL_EDITOR_STYLES],
  template: `
    <input #editInput type="number" class="cell-input"
      [(ngModel)]="editingValue"
      (keydown)="onKeydown($event)"
      [step]="step"
      [attr.aria-label]="'Editing ' + column.label"
      [attr.aria-describedby]="ariaDescribedBy"
      [attr.aria-invalid]="hasError || null"
      [attr.aria-required]="isRequired || null" />
  `,
})
export class NumberEditorComponent extends BaseInputEditor {
  @Input() step: string | number = 'any';

  protected override syncValue(val: string): void {
    this.editingValue = val === '' ? null : Number(val);
  }
}
